import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "EventsModule"
const debug = false

export class EventsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.EVENTS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                           = "Events"
        this.description                    = "The Events module in GoodDay offers a comprehensive solution for managing various types of events across your organization. With this module, you can create events of three distinct types: Organization events, Project events, and Personal events, each serving different purposes and contexts.\n" +
            "\n" +
            "Organization events encompass holidays and generic events that are relevant to the entire organization. These events may include company-wide holidays, team-building activities, or other organization-wide gatherings.\n" +
            "\n" +
            "Project events include generic project events and milestones, providing a platform to track and celebrate important milestones or project-specific events within your projects. Whether it's a project kickoff meeting, a key deliverable milestone, or a project review session, the Project events category allows you to keep your project timelines and progress organized.\n" +
            "\n" +
            "Personal events cater to individual needs and include vacations, travel plans, sick leaves, and other personal commitments. This category allows users to manage their personal schedules efficiently within the GoodDay platform, ensuring transparency and coordination between personal and professional commitments."
        this.svgIcon                        = "isvg-events"
        this.settingsMenuTopCategory        = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                      = "Productivity & Collaboration"
        this.settingsUrl                    = "settings/events"
        this.parentSection                  = SettingsParentSection.PRODUCTIVITY

        this.canDisable                     = false
        this._isEnabled                     = true // because this.canDisable false
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}